import { gql } from "@apollo/client";

export const EDIT_INITIATIVE = gql`
  mutation EditInitiative($data: EditInitiativeInputData!) {
    editInitiative(data: $data) {
      id
      serviceId
      organizationId
      name
      description
      address
      images
      service {
        name
      }
    }
  }
`;
